import { Eye, Mail } from "lucide-react";
import { formatDateTime } from "../../utils/applicationFormatters";
import { getMailgunLogReadUrl } from "@/lib/utils/reportsNavigation";
import styles from "../../styles/applicationDetail.module.css";
import type { NoteLogRow } from "../../types/tabs";
import type { NotesTabEmailHistorySectionProps } from "../../types";

export function NotesTabEmailHistorySection({
  tab,
}: NotesTabEmailHistorySectionProps) {
  const { mailLogsList, handleViewConversationHistory } = tab;

  return (
    <div className={styles.section} data-testid="application-notes-tab-section-email-history">
      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>
          <span className={styles.sectionTitleIcon} aria-hidden="true">
            <Mail className="h-4 w-4" />
          </span>
          Email History
        </h2>
        {mailLogsList.length > 0 ? (
          <button
            type="button"
            className={styles.btnSmall}
            onClick={() => handleViewConversationHistory()}
            data-testid="application-notes-tab-view-conversation-button"
          >
            View Conversation History
          </button>
        ) : null}
      </div>
      <div className={styles.tableResponsive}>
        <table
          className={`${styles.table} ${styles.communicationHistoryTable}`}
          data-testid="application-notes-tab-email-history-table"
        >
          <thead>
            <tr>
              <th>TO</th>
              <th>Subject</th>
              <th>Date / Time</th>
              <th aria-label="Actions" />
            </tr>
          </thead>
          <tbody>
            {mailLogsList.length > 0 ? (
              mailLogsList.map((log: NoteLogRow, index: number) => (
                <tr
                  key={log.id ?? log.mail_log_id ?? index}
                  className={styles.communicationHistoryRowClickable}
                  onClick={() => handleViewConversationHistory(log, index)}
                >
                  <td className={styles.historyLogToCell}>
                    <Mail
                      className={styles.historyLogIcon}
                      size={16}
                      aria-hidden
                    />
                    <span>{log.to || log.to_email || log.email || "N/A"}</span>
                  </td>
                  <td>{log.subject || log.email_type || "N/A"}</td>
                  <td>{formatDateTime(log.created_at)}</td>
                  <td>
                    {/* Angular: *ngIf="mailLog?.source === 'mailgun'" */}
                    {log.source === "mailgun" ? (
                      <a
                        href={getMailgunLogReadUrl(log.id ?? "")}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.historyLogActionLink}
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                        title="View Log"
                        aria-label="View mailgun log"
                        data-testid={`application-notes-tab-email-history-mailgun-log-${log.id}`}
                      >
                        <Eye size={16} />
                      </a>
                    ) : null}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4} className={styles.historyLogEmptyCell}>
                  No email history
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
